import { getQueryParam } from '@mi-front/core';
import { Box } from '@mui/material';

export function Debug({ children }: { children: React.ReactNode }) {
  return getQueryParam('debug') ? <Box typography="caption">{children}</Box> : null;
}
